import { Controller } from "@hotwired/stimulus"

// Persists the daisyUI theme-controller selection to a cookie so the chosen
// theme survives reloads and Turbo navigations (the server renders the matching
// radio as `checked`, and daisyUI applies the theme via CSS — no JS needed to
// apply it, only to remember it). A Stimulus controller rather than an inline
// script keeps this CSP-safe and avoids duplicate listeners across navigations.
// Logo images are the one thing CSS can't retheme: their per-theme variants are
// separate files in public/logos, so `persist` also points every
// `img[data-theme-logo]` at the selected theme's file (the server renders the
// matching src on load — see ApplicationHelper#theme_logo_path).
export default class extends Controller {
  persist(event: Event) {
    const input = event.target as HTMLInputElement
    document.cookie = `theme=${input.value};path=/;max-age=31536000;SameSite=Lax`

    document.querySelectorAll<HTMLImageElement>("img[data-theme-logo]").forEach((img) => {
      img.src = `/logos/sweezy-cursors-logotype-${input.value}.svg`
    })
  }
}
